import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "task-manager",
  "use": "task-manager-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"task-manager\"><path d=\"M7.875 20.384h-5c-.69 0-1.25-.56-1.25-1.25V2.884c0-.69.56-1.25 1.25-1.25h8.857c.332 0 .65.132.884.366l4.893 4.893c.234.235.366.552.366.884v.107\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M11.625 1.634v5c0 .69.56 1.25 1.25 1.25h5M7.808 9.016L6.03 11.384a.625.625 0 01-.942.067l-.964-.963M7.808 14.64L6.03 17.01a.625.625 0 01-.942.066l-.964-.964M10.375 11.634H13.5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path clip-rule=\"evenodd\" d=\"M19.86 13.4l-6.36 6.36-3.125.624L11 17.26l6.36-6.359a1.762 1.762 0 012.492 0l.007.008a1.763 1.763 0 010 2.492z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/task-manager.svg
// module id = n9cs
// module chunks = 38 43